import { useId } from 'react';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';
import { getDefaultHeight } from '../utils/get-default-height.js';

const SkipDialogGraphic = svgProps => {
  const id = useId();
  return /*#__PURE__*/jsxs(SVG, {
    viewBox: "0 0 226 158",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 158),
    ...svgProps,
    fill: "none",
    children: [/*#__PURE__*/jsx("path", {
      d: "M226 81.4772C226 123.74 175.408 158 113 158 50.5918 158 0 123.74 0 81.4772 0 39.2149 23.5417-17.1105 113 4.9544c82.396 20.323 113 34.2605 113 76.5228Z",
      fill: "#090B19",
      fillOpacity: ".03"
    }), /*#__PURE__*/jsx("g", {
      filter: `url(#${id}-a)`,
      children: /*#__PURE__*/jsx("rect", {
        x: "33",
        y: "19",
        width: "160",
        height: "110",
        rx: "2",
        fill: "#fff"
      })
    }), /*#__PURE__*/jsx("rect", {
      x: "80",
      y: "65",
      width: "67",
      height: "44",
      rx: "2",
      fill: "#F0F0F1"
    }), /*#__PURE__*/jsx("g", {
      filter: `url(#${id}-b)`,
      children: /*#__PURE__*/jsx("rect", {
        x: "94",
        y: "86",
        width: "40",
        height: "10",
        rx: "1",
        fill: "#fff"
      })
    }), /*#__PURE__*/jsx("path", {
      d: "M90.7489 83v-6.67h1.42V83h-1.42Zm5.8441 0-1.28-1.86-.58.62V83h-1.27v-6.67h1.27v3.99l1.83-2.15h1.56l-1.91 2.19 1.97 2.64h-1.59Zm5.352 0-1.28-1.86-.58.62V83h-1.2704v-6.67h1.2704v3.99l1.83-2.15h1.56l-1.91 2.19 1.97 2.64h-1.59Zm8.04 0v-.61c-.33.37-.91.73-1.7.73-1.06 0-1.56-.58-1.56-1.52v-3.43h1.27v2.93c0 .67.35.89.89.89.49 0 .88-.27 1.1-.55v-3.27h1.27V83h-1.27Zm5.851 0v-.61c-.38.47-.91.73-1.49.73-1.22 0-2.14-.92-2.14-2.53 0-1.58.91-2.54 2.14-2.54.57 0 1.11.25 1.49.74v-2.46h1.28V83h-1.28Zm0-1.56v-1.71c-.22-.32-.67-.55-1.1-.55-.72 0-1.22.57-1.22 1.41 0 .83.5 1.4 1.22 1.4.43 0 .88-.23 1.1-.55Zm2.819 1.56v-3.72h-.8v-1.11h.8v-.26c0-1.05.68-1.68 1.63-1.68.36 0 .69.08.92.2l-.26.9c-.11-.07-.26-.1-.41-.1-.36 0-.6.24-.6.7v.24h.98v1.11h-.98V83h-1.28Zm3.012.75c.11.05.28.08.4.08.33 0 .55-.09.67-.35l.18-.41-1.96-4.9h1.36l1.26 3.36 1.26-3.36h1.37l-2.27 5.62c-.36.91-1 1.15-1.83 1.17-.15 0-.47-.03-.63-.07l.19-1.14Zm5.107-.75v-6.67h1.27V83h-1.27Zm5.849 0v-.61c-.38.47-.91.73-1.49.73-1.22 0-2.14-.92-2.14-2.53 0-1.58.91-2.54 2.14-2.54.57 0 1.11.25 1.49.74v-2.46h1.28V83h-1.28Zm0-1.56v-1.71c-.22-.32-.67-.55-1.1-.55-.72 0-1.22.57-1.22 1.41 0 .83.5 1.4 1.22 1.4.43 0 .88-.23 1.1-.55Zm4.159 1.68c-.89 0-1.37-.46-1.37-1.32v-2.52h-.8v-1.11h.8v-1.32h1.28v1.32h.98v1.11h-.98v2.18c0 .3.16.53.44.53.19 0 .37-.07.44-.14l.27.96c-.19.17-.53.31-1.06.31Z",
      fill: "#757783"
    }), /*#__PURE__*/jsx("rect", {
      x: "3",
      y: "65",
      width: "67",
      height: "44",
      rx: "2",
      fill: "#DFFCD2"
    }), /*#__PURE__*/jsx("g", {
      filter: `url(#${id}-c)`,
      children: /*#__PURE__*/jsx("rect", {
        x: "17",
        y: "86",
        width: "40",
        height: "10",
        rx: "1",
        fill: "#fff"
      })
    }), /*#__PURE__*/jsx("path", {
      d: "M20.3748 83v-6.67h2.63c2.09 0 3.54 1.33 3.54 3.34s-1.45 3.33-3.54 3.33h-2.63Zm1.42-1.25h1.21c1.32 0 2.09-.95 2.09-2.08 0-1.18-.72-2.09-2.09-2.09h-1.21v4.17Zm6.3578-4.29c-.41 0-.76-.34-.76-.76s.35-.76.76-.76c.42 0 .76.34.76.76s-.34.76-.76.76Zm-.63 5.54v-4.83h1.27V83h-1.27Zm4.1493.12c-.89 0-1.37-.46-1.37-1.32v-2.52h-.8v-1.11h.8v-1.32h1.28v1.32h.98v1.11h-.98v2.18c0 .3.16.53.44.53.19 0 .37-.07.44-.14l.27.96c-.19.17-.53.31-1.06.31Zm3.8975-.75.55-.89c.35.33 1.07.66 1.67.66.55 0 .81-.19.81-.49 0-.34-.42-.46-.97-.57-.83-.16-1.9-.36-1.9-1.51 0-.81.71-1.52 1.98-1.52.82 0 1.47.28 1.94.66l-.5.87c-.29-.31-.84-.56-1.43-.56-.46 0-.76.17-.76.45 0 .3.38.41.92.52.83.16 1.94.38 1.94 1.58 0 .89-.75 1.55-2.09 1.55-.84 0-1.65-.28-2.16-.75Zm6.4356.63-1.94-4.83h1.36l1.26 3.36 1.26-3.36h1.37L43.375 83h-1.37Zm6.777 0v-.5c-.33.39-.9.62-1.53.62-.77 0-1.68-.52-1.68-1.6 0-1.13.91-1.54 1.68-1.54.64 0 1.21.2 1.53.59v-.67c0-.49-.42-.81-1.06-.81-.52 0-1 .19-1.41.57l-.48-.85c.59-.52 1.35-.76 2.11-.76 1.1 0 2.11.44 2.11 1.83V83h-1.27Zm0-1.16v-.6c-.21-.28-.61-.42-1.02-.42-.5 0-.91.27-.91.73 0 .45.41.71.91.71.41 0 .81-.14 1.02-.42ZM51.3116 83v-4.83h1.27v.66c.34-.43.94-.77 1.54-.77v1.24c-.09-.02-.21-.03-.35-.03-.42 0-.98.23-1.19.54V83h-1.27Z",
      fill: "#000"
    }), /*#__PURE__*/jsx("rect", {
      x: "154",
      y: "65",
      width: "67",
      height: "44",
      rx: "2",
      fill: "#DFFCD2"
    }), /*#__PURE__*/jsx("g", {
      filter: `url(#${id}-d)`,
      children: /*#__PURE__*/jsx("rect", {
        x: "168",
        y: "86",
        width: "40",
        height: "10",
        rx: "1",
        fill: "#fff"
      })
    }), /*#__PURE__*/jsx("path", {
      d: "M171.375 83v-6.67h2.63c2.09 0 3.54 1.33 3.54 3.34s-1.45 3.33-3.54 3.33h-2.63Zm1.42-1.25h1.21c1.32 0 2.09-.95 2.09-2.08 0-1.18-.72-2.09-2.09-2.09h-1.21v4.17Zm6.358-4.29c-.41 0-.76-.34-.76-.76s.35-.76.76-.76c.42 0 .76.34.76.76s-.34.76-.76.76Zm-.63 5.54v-4.83h1.27V83h-1.27Zm4.149.12c-.89 0-1.37-.46-1.37-1.32v-2.52h-.8v-1.11h.8v-1.32h1.28v1.32h.98v1.11h-.98v2.18c0 .3.16.53.44.53.19 0 .37-.07.44-.14l.27.96c-.19.17-.53.31-1.06.31Zm3.897-.75.55-.89c.35.33 1.07.66 1.67.66.55 0 .81-.19.81-.49 0-.34-.42-.46-.97-.57-.83-.16-1.9-.36-1.9-1.51 0-.81.71-1.52 1.98-1.52.82 0 1.47.28 1.94.66l-.5.87c-.29-.31-.84-.56-1.43-.56-.46 0-.76.17-.76.45 0 .3.38.41.92.52.83.16 1.94.38 1.94 1.58 0 .89-.75 1.55-2.09 1.55-.84 0-1.65-.28-2.16-.75Zm6.436.63-1.94-4.83h1.36l1.26 3.36 1.26-3.36h1.37l-1.94 4.83h-1.37Zm6.777 0v-.5c-.33.39-.9.62-1.53.62-.77 0-1.68-.52-1.68-1.6 0-1.13.91-1.54 1.68-1.54.64 0 1.21.2 1.53.59v-.67c0-.49-.42-.81-1.06-.81-.52 0-1 .19-1.41.57l-.48-.85c.59-.52 1.35-.76 2.11-.76 1.1 0 2.11.44 2.11 1.83V83h-1.27Zm0-1.16v-.6c-.21-.28-.61-.42-1.02-.42-.5 0-.91.27-.91.73 0 .45.41.71.91.71.41 0 .81-.14 1.02-.42Zm2.53 1.16v-4.83h1.27v.66c.34-.43.94-.77 1.54-.77v1.24c-.09-.02-.21-.03-.35-.03-.42 0-.98.23-1.19.54V83h-1.27Z",
      fill: "#000"
    }), /*#__PURE__*/jsx("path", {
      d: "M61 55.8284C72.857 31.0267 141.541 27.0452 161 58",
      stroke: "#000",
      strokeWidth: "1.5",
      strokeLinecap: "round"
    }), /*#__PURE__*/jsx("path", {
      d: "m152 55.875 9.4 3.525 3.525-9.4",
      stroke: "#000",
      strokeWidth: "1.5",
      strokeLinecap: "round"
    }), /*#__PURE__*/jsxs("defs", {
      children: [/*#__PURE__*/jsxs("filter", {
        id: `${id}-a`,
        x: "23",
        y: "9",
        width: "180",
        height: "130",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/jsx("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/jsx("feOffset", {}), /*#__PURE__*/jsx("feGaussianBlur", {
          stdDeviation: "5"
        }), /*#__PURE__*/jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/jsx("feColorMatrix", {
          values: "0 0 0 0 0.0352941 0 0 0 0 0.0431373 0 0 0 0 0.0980392 0 0 0 0.1 0"
        }), /*#__PURE__*/jsx("feBlend", {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_4012_9022"
        }), /*#__PURE__*/jsx("feBlend", {
          in: "SourceGraphic",
          in2: "effect1_dropShadow_4012_9022",
          result: "shape"
        })]
      }), /*#__PURE__*/jsxs("filter", {
        id: `${id}-b`,
        x: "94",
        y: "86",
        width: "40",
        height: "11",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/jsx("feBlend", {
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/jsx("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/jsx("feOffset", {
          dy: "1"
        }), /*#__PURE__*/jsx("feGaussianBlur", {
          stdDeviation: "1"
        }), /*#__PURE__*/jsx("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: "-1",
          k3: "1"
        }), /*#__PURE__*/jsx("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/jsx("feBlend", {
          in2: "shape",
          result: "effect1_innerShadow_4012_9022"
        })]
      }), /*#__PURE__*/jsxs("filter", {
        id: `${id}-c`,
        x: "17",
        y: "86",
        width: "40",
        height: "11",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/jsx("feBlend", {
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/jsx("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/jsx("feOffset", {
          dy: "1"
        }), /*#__PURE__*/jsx("feGaussianBlur", {
          stdDeviation: "1"
        }), /*#__PURE__*/jsx("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: "-1",
          k3: "1"
        }), /*#__PURE__*/jsx("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/jsx("feBlend", {
          in2: "shape",
          result: "effect1_innerShadow_4012_9022"
        })]
      }), /*#__PURE__*/jsxs("filter", {
        id: `${id}-d`,
        x: "168",
        y: "86",
        width: "40",
        height: "11",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/jsx("feBlend", {
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/jsx("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/jsx("feOffset", {
          dy: "1"
        }), /*#__PURE__*/jsx("feGaussianBlur", {
          stdDeviation: "1"
        }), /*#__PURE__*/jsx("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: "-1",
          k3: "1"
        }), /*#__PURE__*/jsx("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/jsx("feBlend", {
          in2: "shape",
          result: "effect1_innerShadow_4012_9022"
        })]
      })]
    })]
  });
};

export { SkipDialogGraphic };
//# sourceMappingURL=dialog.skip.js.map
